// extracted by mini-css-extract-plugin
export const sectionWhyHomestaHero = "whyHomestaHero-module--sectionWhyHomestaHero--3nHwF";
export const heroWrap = "whyHomestaHero-module--heroWrap--1ZMM4";
export const heroContainer = "whyHomestaHero-module--heroContainer--2Ueb_";
export const heroContentWrap = "whyHomestaHero-module--heroContentWrap--2tW8B";
export const hasSearchBar = "whyHomestaHero-module--hasSearchBar--3BO40";
export const contentWrap = "whyHomestaHero-module--contentWrap--2lubl";
export const tagSearchBar = "whyHomestaHero-module--tagSearchBar--PAakO";
export const addressSearchBtn = "whyHomestaHero-module--addressSearchBtn--2ghYw";
export const ctaWrap = "whyHomestaHero-module--ctaWrap--2O0XH";
export const bgCircle = "whyHomestaHero-module--bgCircle--1TJ_Y";
export const mobileImage = "whyHomestaHero-module--mobileImage--mIAPk";
export const featuredImageWrap = "whyHomestaHero-module--featuredImageWrap--3N4nA";
export const preSectionWrap = "whyHomestaHero-module--preSectionWrap--3yPEo";
export const sectionContainer = "whyHomestaHero-module--sectionContainer--1lTIt";
export const videoEmbed = "whyHomestaHero-module--videoEmbed--2KpWZ";
export const sectionContentWrap = "whyHomestaHero-module--sectionContentWrap--3aQKc";
export const sectionBg = "whyHomestaHero-module--sectionBg--1lFm7";